import { render, staticRenderFns } from "./abysign.vue?vue&type=template&id=46a6f10d&"
import script from "./abysign.vue?vue&type=script&lang=js&"
export * from "./abysign.vue?vue&type=script&lang=js&"
import style0 from "./abysign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
